// View text field and be edited. Field also has auto-expand feature.
/*
  Autocomplete accepts following parameters: 
  1) label (String) 
  2) value (String)
  3) fieldId (String) - works as ref/name.
  4) editMode (Boolean) - decides which mode to show initially (edit/view). Save/Cancel is not available, onBlur event triggers save action.
  5) saveChanges (Function) - passed as prop from parent to this component and emitted whenever changes are saved.

  v-model works for this component to capture the value
 */
<template>
  <div class="flex flex-col p-2 flex-no-shrink flex-no-grow rounded-sm bg-white" style="width: 100%">
    <div class="flex justify-between w-full mb-2 flex-no-shrink flex-no-grow">
      <div class="flex mr-auto">
        <label class="text-sm font-semibold text-grey-dark mr-1 tracking-wide" for="prescribe_drug" style="text-transform: uppercase">
          {{label}}
        </label>
      </div>
      <div class="flex ml-auto mr-1" v-if="!inEdit && canEdit" @click="edit()">
        <span class="justify-center cursor-pointer text-blue text-sm font-semibold">Edit</span>
      </div>
      <div class="flex ml-auto" v-if="inEdit">        
        <span v-if="!editMode || editMode === 'false'" @click="save()" class="justify-center cursor-pointer text-blue text-sm font-semibold">Save</span>
        <span v-if="!editMode || editMode === 'false'" @click="cancel()" class="pl-2 justify-center cursor-pointer text-grey-light text-sm font-semibold">Cancel</span>
      </div>
    </div>
    <div v-if="!inEdit">
      <p class="flex flex-col text-grey-darker text-m" v-html="selectedItem.join(',')"></p>
    </div>
    <div v-else class="flex-no-shrink flex-no-grow relative auto-complete-container">
      <multiselect :id="'editor_'+fieldId" v-model="selectedItem" :options="itemList" placeholder="Type to search" :value="selectedItem"
      @search-change="onDivInput($event)" :searchable="true" :multiple="true"></multiselect>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: ['value', 'label', 'fieldId', 'editMode', 'list', 'error'],
  data () {
    let editing = false
    if (this.editMode && this.editMode === 'true') {
      editing = true
    }
    return {
      inEdit: editing,
      itemList: this.list,
      isLoading: false,
      selectedItem: this.value ? this.value.split(';') : []
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile'
    }),
    canEdit: function () {
      if (this.customer) {
        if (this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed') {
          return false
        } else {
          return true
        }
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.selectedItem = newVal.split(';')
        } else {
          this.selectedItem = []
        }
      }
    },
    list: function (val) {
      this.itemList = val
    },
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!this.value) {
          this.selectedItem = []
          return
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    edit: function () {
      this.inEdit = true
    },
    save: function () {
      if (this.error && this.error.hasError) {
        this.$toast.open({ message: this.error.message ? this.error.message : 'Something went wrong', type: 'error', position: 'top', queue: false })
        return
      }
      if (this.selectedItem.length > 0) {
        this.inEdit = false
        this.$emit('saveChange', {[this.fieldId]: this.selectedItem.join(';')})
        this.$store.dispatch('textField/updateTextFieldState', {inEdit: false, field: this.fieldId})
      }
      if (this.selectedItem.length === 0) {
        this.$toast.open({
          message: 'Please choose any option to save',
          type: 'error',
          position: 'top',
          queue: false
        })
        return
      }
    },
    cancel: function () {
      this.inEdit = false
      this.$store.dispatch('textField/updateTextFieldState', {inEdit: false, field: this.fieldId})
    },
    onDivInput: function (value) {
      if (value.length > 0) {
        this.$emit('input', value)
        this.$emit('searchInput', value)
        this.$store.dispatch('textField/updateTextFieldState', {inEdit: true, field: this.fieldId})
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:2rem;text-align:left;color:#35495e;}
.multiselect__input{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:2px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top;}
.multiselect__input:focus{border-color:#2168f3;outline:none;}
.multiselect__tags{min-height:2rem;display:block;padding:8px 40px 0 8px;border-radius:2px;border:1px solid #b8c2cc;background:#fff;font-size:14px;}
.multiselect__select{line-height:12px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer;}
.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #b8c2cc;border-top:none;border-bottom-left-radius:2px;border-bottom-right-radius:2px;z-index:3;-webkit-overflow-scrolling:touch;}
</style>



// WEBPACK FOOTER //
// src/components/common/Autocomplete.vue